import { z } from 'zod';

export enum UserRoles {
  ADMIN = 'admin',
  MANAGER = 'manager',
  USER = 'user',
}

export const userRoleSchema = z.enum(UserRoles);
